var _style, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegacyLeaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C5D30;}\n\t.st1{fill:#8F920B;}\n\t.st2{fill:#322C3E;}\n\t.st3{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.6,437.6c0,0,28.4,246.7,301.7,171.4C462.3,609,426.9,364.2,160.6,437.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.9,664.3c0,0,28.4,246.7,301.7,171.4C491.5,835.7,456,590.8,189.9,664.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M839.4,432.2c0,0-227.8-98.9-299.2,175.7C540.2,607.9,769.8,699.6,839.4,432.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M810.1,658.9c0,0-227.8-98.9-299.2,175.7C510.9,834.5,740.6,926.3,810.1,658.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M501.5,150c0,0-199.5,148,2.4,347.1C503.9,497.1,698.1,344,501.5,150z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 1000,
    height: 1000
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegacyLeaves);
export default __webpack_public_path__ + "static/media/legacy-leaves.2ac1ae59c1abcdc2949e98220a8b1afb.svg";
export { ForwardRef as ReactComponent };